import { productRequests } from './product-requests';
import { voucherRequests } from './voucher-requests';

export const requests = {
  product: productRequests,
  voucher: voucherRequests,
};
